import React from 'react';
import { Sparkle } from './Sparkle';
import { CtaButton } from './CtaButton';
import { price, valueStack } from '../data/content';
type OfferCardProps = {
  id?: string;
};
export function OfferCard({
  id
}: OfferCardProps) {
  return <section id={id} aria-label="Oferta" className="scroll-mt-20 bg-kraft px-4 py-10 sm:px-5 sm:py-16 lg:py-24" data-id="element-92" data-mp="rhqbutuxh8qc">
      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-ink bg-cream p-5 shadow-[5px_5px_0_0_#141210] sm:p-10 sm:shadow-[8px_8px_0_0_#141210]" data-id="element-93" data-mp="mjycxfvv8mcn">
        <div className="flex items-center justify-center gap-3" data-id="element-94" data-mp="1f6j167h1oibz">
          <Sparkle className="h-5 w-5" data-id="element-95" data-mp="1ag2nqnd84wpm" />
          <h2 className="font-display text-xl font-black uppercase tracking-tight sm:text-3xl" data-id="element-96" data-mp="1af107jf0uhr0">Lo que te llevas hoy</h2>
          <Sparkle className="h-5 w-5" data-id="element-97" data-mp="15gg7s660h2d4" />
        </div>

        <ul className="mt-5 text-sm sm:mt-8 sm:text-base" data-id="element-98" data-mp="22wvi27u9ppep">
          {valueStack.map(v => <li key={v.item} className="flex items-baseline gap-2 py-2.5" data-id="element-99" data-mp="1y5n91cwuo622">
              <span className="font-medium" data-id="element-100" data-mp="1y3k7pwq8yqi1">{v.item}</span>
              <span aria-hidden="true" className="flex-1 border-b-2 border-dotted border-kraft-dark/50" data-id="element-101" data-mp="8guhx33g8uft" />
              <span className="whitespace-nowrap font-display font-bold text-ink-soft" data-id="element-102" data-mp="ddur3mvlidb5">{v.value}</span>
            </li>)}
        </ul>

        <div className="mt-6 flex items-baseline justify-between border-t-2 border-ink pt-4" data-id="element-103" data-mp="3vqsu62nopm9j">
          <span className="font-medium" data-id="element-104" data-mp="3n9v877b3mvx">Todo tiene un valor de</span>
          <s className="font-display text-2xl font-black text-ink-soft" data-id="element-105" data-mp="3lto2xoezf0lv">{price.total}</s>
        </div>

        <div className="mt-6 text-center sm:mt-8" data-id="element-106" data-mp="3qullw37tfyof">
          <p className="font-display text-sm font-extrabold uppercase tracking-widest text-rust-dark" data-id="element-107" data-mp="3cu13h85tc4vg">Solo hoy</p>
          <p className="font-display text-6xl font-black leading-none tracking-tight sm:text-8xl" data-id="element-108" data-mp="3gvcyjt7ghib1">{price.today}</p>
          <p className="mt-2 text-sm text-ink-soft" data-id="element-109" data-mp="1b2ekntw2rga2">Pago único · Acceso inmediato</p>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-110" data-mp="1f4jcqo6vk4ul">
          <CtaButton label="¡Sí, quiero mi diario ahora!" align="center" showNote data-id="element-111" data-mp="1f3giq7e99mag" />
        </div>
      </div>
    </section>;
}